import React, { useRef, useEffect, useState } from 'react';

import { Wrapper, Triangle, Content, Button, ContentWrapper } from './styled';

import imgClose from './assets/close.svg';
import imgClosePurple from './assets/closePurple.svg';

interface IProps {
  buttonSize?: string;
  iconSize?: string;
  list?: boolean;
  width?: string;
  text?: string;
  title?: string;
  children?: any;
  boxToRight?: boolean;
}

const Tooltip = ({
  buttonSize,
  iconSize,
  list,
  width,
  text,
  title,
  children,
  boxToRight
}: IProps) => {
  const [show, setShow] = useState<boolean>(false);
  const refWrapper = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    window.addEventListener('resize', () => {
      setShow(false);
    });

    window.addEventListener('click', (ev) => {
      if (ev.target instanceof Element && refWrapper.current) {
        if (!refWrapper.current.contains(ev.target)) setShow(false);
      }
    });
  }, [refWrapper]);

  return (
    <Wrapper ref={refWrapper}>
      <Button
        iconSize={iconSize}
        type="button"
        className="init"
        data-testid="tooltip-toggle-button"
        onClick={() => setShow(!show)}
      >
        <img src={imgClosePurple} alt="close" />
      </Button>
      <Triangle active={show} buttonSize={buttonSize} />
      <Content active={show} width={width} boxToRight={boxToRight}>
        <ContentWrapper buttonSize={buttonSize}>
          {title && <h6>{title}</h6>}
          {text && <p>{text}</p>}
          {list && (
            <ul>
              <li>“B” es el Pabellón</li>
              <li>“01” es el Piso</li>
              <li>“19” en el Nº de ambiente</li>
            </ul>
          )}
          {children && <>{children}</>}
        </ContentWrapper>
        <Button
          iconSize={iconSize}
          buttonSize={buttonSize}
          type="button"
          onClick={() => setShow(false)}
          data-testid="tooltip-close-button"
        >
          <img src={imgClose} alt="close" />
        </Button>
      </Content>
    </Wrapper>
  );
};

export default Tooltip;
